
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_y1yrh_lwuxf_93",
  "root": "awsui_root_y1yrh_lwuxf_111",
  "series--highlighted": "awsui_series--highlighted_y1yrh_lwuxf_123",
  "series--dimmed": "awsui_series--dimmed_y1yrh_lwuxf_127",
  "series--threshold": "awsui_series--threshold_y1yrh_lwuxf_131",
  "popover-divider": "awsui_popover-divider_y1yrh_lwuxf_136"
};
  